import React, { useEffect, useState } from 'react'
import FinancePartnerModel from './models/FinancePartnerModel'

function ViewFinancePartner({ FinancePartnerData }) {
  const [financePartnerData, setFinancePartnerData] = useState(new FinancePartnerModel())

  useEffect(() => {
    setFinancePartnerData(FinancePartnerData)
  }, [FinancePartnerData])

  return (
    <>
      <div className="row">
        <div className="mb-3 add-product">
          <label className="form-label">Finance Partner Name</label>
          <input type="text" className="form-control" value={financePartnerData.FinancePartnerName ?? ''} disabled />
        </div>
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Interest Rate (%)</label>
          <input type="text" className="form-control" value={financePartnerData.InterestRate ?? ''} disabled />
        </div>
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Minimum Down Payment</label>
          <input type="text" className="form-control" value={financePartnerData.MinimumDownPayment ?? ''} disabled />
        </div>
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Contact Person 1</label>
          <input type="text" className="form-control" value={financePartnerData.ContactPerson1 ?? ''} disabled />
        </div>
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Contact Phone 1</label>
          <input type="text" className="form-control" value={financePartnerData.ContactPhone1 ?? ''} disabled />
        </div>
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Contact Person 2</label>
          <input type="text" className="form-control" value={financePartnerData.ContactPerson2 ?? ''} disabled />
        </div>
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Contact Phone 2</label>
          <input type="text" className="form-control" value={financePartnerData.ContactPhone2 ?? ''} disabled />
        </div>
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Email</label>
          <input type="text" className="form-control" value={financePartnerData.EmailId ?? ''} disabled />
        </div>
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Sequance</label>
          <input type="text" className="form-control" value={financePartnerData.Sequance ?? ''} disabled />
        </div>
      </div>
    </>
  )
}

export default ViewFinancePartner
